/* SafeWake Theme JS — Phase 8 */
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

/* === Global toast: slides down from top, auto-dismiss ===
   Exposed as window.swToast(msg, opts?). Used by cart-add handlers
   to confirm "Added to cart" immediately — no guessing. */
(function() {
  var el = null, dismissTimer = null;
  function ensureEl() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'sw-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    document.body.appendChild(el);
    return el;
  }
  window.swToast = function(message, opts) {
    opts = opts || {};
    var dur = opts.duration || 2400;
    var variant = opts.variant || 'success'; /* success | info | error */
    var node = ensureEl();
    node.className = 'sw-toast sw-toast--' + variant;
    /* Simple SVG checkmark / icon prefix */
    var icon = variant === 'success'
      ? '<svg class="sw-toast__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>'
      : variant === 'error'
      ? '<svg class="sw-toast__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
      : '<svg class="sw-toast__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/></svg>';
    node.innerHTML = icon + '<span class="sw-toast__msg"></span>';
    node.querySelector('.sw-toast__msg').textContent = message;
    /* Force reflow so the transition kicks in on re-show */
    void node.offsetWidth;
    node.classList.add('is-visible');
    if (dismissTimer) clearTimeout(dismissTimer);
    dismissTimer = setTimeout(function() {
      node.classList.remove('is-visible');
    }, dur);
  };
})();

/* === Mobile Menu === */
(function() {
  var menu = document.getElementById('mobile-menu');
  var openBtn = document.getElementById('mobile-menu-open');
  var closeBtn = document.getElementById('mobile-menu-close');
  var backdrop = document.getElementById('mobile-menu-backdrop');
  if (!menu || !openBtn) return;

  function open() {
    menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (backdrop) backdrop.addEventListener('click', close);
})();

/* === Cart Drawer === */
(function() {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  window.openCartDrawer = function() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  window.closeCartDrawer = function() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  /* Delegated close handlers — survive innerHTML refreshes from Section API */
  drawer.addEventListener('click', function(e) {
    if (e.target && (e.target.id === 'cart-drawer-close' || e.target.closest('#cart-drawer-close'))) {
      window.closeCartDrawer();
    }
    if (e.target && e.target.id === 'cart-drawer-backdrop') {
      window.closeCartDrawer();
    }
    if (e.target.closest('[data-cart-close-link]')) {
      /* Links inside drawer — close drawer before navigating */
      window.closeCartDrawer();
    }
  });

  /* Cart icon buttons open the drawer */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-open]');
    if (!btn) return;
    e.preventDefault();
    window.openCartDrawer();
  });

  /* Esc key closes */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) window.closeCartDrawer();
  });
})();

/* === Cart Drawer Item Controls (qty, remove) === */
(function() {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        if (!sections || !sections['cart-drawer']) return;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = sections['cart-drawer'];
        var fresh = wrapper.querySelector('#cart-drawer');
        if (fresh && drawer) {
          var wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = fresh.innerHTML;
          if (wasOpen) drawer.classList.add('is-open');
        }
      });
  }

  function changeQty(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.header__cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        return refreshDrawer();
      });
  }

  /* Delegated click — +/−, remove */
  drawer.addEventListener('click', function(e) {
    var qtyBtn = e.target.closest('[data-cart-qty-btn]');
    if (qtyBtn) {
      var key = qtyBtn.getAttribute('data-key');
      var delta = parseInt(qtyBtn.getAttribute('data-delta'), 10) || 0;
      /* v7 fix: line item key contains a colon (VARIANT_ID:HASH) which breaks CSS attribute selectors.
         Instead, find the input by walking up to the cart-drawer__item container. */
      var itemEl = qtyBtn.closest('.cart-drawer__item');
      var input = itemEl ? itemEl.querySelector('[data-cart-qty-input]') : null;
      if (!input) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      input.value = next;
      changeQty(key, next);
      return;
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      changeQty(removeBtn.getAttribute('data-key'), 0);
      return;
    }
  });

  /* Delegated change on qty input */
  drawer.addEventListener('change', function(e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    changeQty(input.getAttribute('data-key'), qty);
  });

  /* v7: Site-wide safety handler for cart qty buttons — catches main-cart, cart-drawer, and any future cart surface */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-qty-btn], [data-cart-qty]');
    if (!btn) return;
    var key = btn.getAttribute('data-key');
    if (!key) return;
    var delta = parseInt(btn.getAttribute('data-delta'), 10) || 0;
    if (!delta) return;
    e.preventDefault();
    var container = btn.closest('.cart-item, .cart-drawer__item');
    var input = container ? container.querySelector('input[type="number"], [data-cart-qty-input]') : null;
    var currentQty = input ? parseInt(input.value, 10) || 0 : 1;
    var nextQty = Math.max(0, currentQty + delta);
    if (input) input.value = nextQty;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: nextQty })
    }).then(function() {
      if (window.location.pathname === '/cart') window.location.reload();
      else if (typeof window.refreshCartDrawer === 'function') window.refreshCartDrawer();
    });
  }, true); /* capture phase so it fires before anything that might preventDefault */
})();

/* === Product Gallery Thumbnails === */
(function() {
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  var mainImg = document.getElementById('main-product-img');
  if (!mainImg || thumbs.length === 0) return;

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var url = this.getAttribute('data-image-url');
      if (url) {
        mainImg.src = url;
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });
})();

/* === Product Gallery Touch Swipe + Mouse Drag === */
(function() {
  var mainImg = document.getElementById('main-product-img');
  var gallery = mainImg ? mainImg.closest('.product-gallery__main') : null;
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  if (!gallery || thumbs.length < 2) return;
  var startX = 0, startY = 0, dragAxis = null, isDragging = false;
  var currentIndex = 0;
  thumbs.forEach(function(t, i) { if (t.classList.contains('active')) currentIndex = i; });
  function goToThumb(index) {
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    currentIndex = index;
    var thumb = thumbs[currentIndex];
    var url = thumb.getAttribute('data-image-url');
    if (url && mainImg) {
      mainImg.style.opacity = '0';
      mainImg.style.transition = 'opacity 0.15s ease';
      setTimeout(function() { mainImg.src = url; mainImg.style.opacity = '1'; }, 150);
    }
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
  gallery.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDragging = true; dragAxis = null;
  }, { passive: true });
  gallery.addEventListener('touchmove', function(e) {
    if (!isDragging || dragAxis) return;
    var dx = Math.abs(e.touches[0].clientX - startX);
    var dy = Math.abs(e.touches[0].clientY - startY);
    if (dx > 8 || dy > 8) {
      dragAxis = dx > dy ? 'x' : 'y';
      if (dragAxis === 'x') e.preventDefault();
    }
  }, { passive: false });
  gallery.addEventListener('touchend', function(e) {
    if (!isDragging) return;
    isDragging = false;
    if (dragAxis !== 'x') return;
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) goToThumb(currentIndex + 1);
      else goToThumb(currentIndex - 1);
    }
  });
  gallery.style.cursor = 'grab';
  var mouseDown = false, mouseStartX = 0;
  gallery.addEventListener('mousedown', function(e) {
    mouseDown = true; mouseStartX = e.clientX;
    gallery.style.cursor = 'grabbing'; e.preventDefault();
  });
  document.addEventListener('mouseup', function(e) {
    if (!mouseDown) return;
    mouseDown = false; gallery.style.cursor = 'grab';
    var diff = mouseStartX - e.clientX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) goToThumb(currentIndex + 1);
      else goToThumb(currentIndex - 1);
    }
  });
})();

/* === Quantity Buttons === */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var container = btn.closest('.product-form__qty, .cart-item__qty');
    if (!container) return;
    var input = container.querySelector('input[type="number"]');
    if (!input) return;
    var val = parseInt(input.value) || 1;
    var min = parseInt(input.min) || 0;
    if (btn.hasAttribute('data-qty-minus')) {
      if (val > min) input.value = val - 1;
    } else {
      input.value = val + 1;
    }
  });
})();

/* === Cookie Consent === */
(function() {
  var banner = document.getElementById('cookie-consent');
  var acceptBtn = document.getElementById('cookie-accept');
  var declineBtn = document.getElementById('cookie-decline');
  if (!banner) return;
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
  if (!getCookie('sw_cookie_consent')) banner.classList.add('is-visible');
  var days = parseInt(banner.getAttribute('data-cookie-days')) || 30;
  function dismiss(value) {
    document.cookie = 'sw_cookie_consent=' + value + ';path=/;max-age=' + (days * 86400) + ';SameSite=Lax';
    banner.classList.remove('is-visible');
  }
  if (acceptBtn) acceptBtn.addEventListener('click', function() { dismiss('accepted'); });
  if (declineBtn) declineBtn.addEventListener('click', function() { dismiss('declined'); });
})();

/* === AJAX Add to Cart (delegated — catches dynamically-added forms) === */
(function() {
  function refreshDrawer() {
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        if (!sections || !sections['cart-drawer']) return;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = sections['cart-drawer'];
        var fresh = wrapper.querySelector('#cart-drawer');
        var existing = document.getElementById('cart-drawer');
        if (fresh && existing) {
          var wasOpen = existing.classList.contains('is-open');
          existing.innerHTML = fresh.innerHTML;
          /* Re-bind close handlers since innerHTML replaced the DOM */
          var closeBtn = existing.querySelector('#cart-drawer-close');
          var backdrop = existing.querySelector('#cart-drawer-backdrop');
          if (closeBtn && window.closeCartDrawer) closeBtn.addEventListener('click', window.closeCartDrawer);
          if (backdrop && window.closeCartDrawer) backdrop.addEventListener('click', window.closeCartDrawer);
          if (wasOpen) existing.classList.add('is-open');
        }
      })
      .catch(function(){});
  }

  document.addEventListener('submit', function(e) {
    var form = e.target.closest('form[action="/cart/add"], form[action^="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    /* Detect Quick Checkout / Buy Now intent — button either has data-buy-now OR name="checkout" */
    var submitter = e.submitter || form.querySelector('[type="submit"]');
    var isBuyNow = submitter && (submitter.hasAttribute('data-buy-now') || submitter.name === 'checkout');

    var formData = new FormData(form);
    var btn = submitter || form.querySelector('[type="submit"]');
    var originalHtml = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      if (!btn.querySelector('svg') && !isBuyNow) btn.textContent = 'Adding…';
    }

    /* Visual: fly-to-cart animation from the card image if we can find one */
    try { flyToCart(form); } catch (e2) {}

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function(res) { return res.json(); })
      .then(function() {
        if (isBuyNow) {
          /* Skip drawer, go straight to checkout */
          window.location.href = '/checkout';
          return null;
        }
        /* Success pulse on the button */
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
          if (!btn.querySelector('svg')) btn.textContent = '✓ Added';
        }
        return Promise.all([
          fetch('/cart.js').then(function(r) { return r.json(); }),
          refreshDrawer()
        ]);
      })
      .then(function(results) {
        if (!results) return; /* buy-now path */
        var cart = results[0];
        if (cart) {
          document.querySelectorAll('.header__cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
            el.classList.remove('header__cart-count--bounce');
            /* Re-trigger bounce animation */
            void el.offsetWidth;
            el.classList.add('header__cart-count--bounce');
          });
        }
        /* Toast-only confirmation. CPO audit: toast + drawer = double confirmation
           interruption. Drawer stays accessible via the header cart icon. */
        if (window.swToast) window.swToast('Added to cart · بكل بساطة');
        setTimeout(function() {
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('is-success');
            btn.innerHTML = originalHtml;
          }
        }, 1400);
      })
      .catch(function() {
        if (window.swToast) window.swToast('Could not add item', { variant: 'error' });
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.innerHTML = originalHtml;
        }
      });
  });

  /* Fly-to-cart animation: clones the product image and animates it toward the cart icon */
  function flyToCart(form) {
    var img = form.closest('[data-cart-item], .coll-product-card, .featured-products__card, .bundle-card, .cart-upsell-card, .rec-card, .product-info')
      && form.closest('[data-cart-item], .coll-product-card, .featured-products__card, .bundle-card, .cart-upsell-card, .rec-card, .product-info').querySelector('img');
    var target = document.querySelector('.header__cart-count, [data-cart-open] svg, [data-cart-open]');
    if (!img || !target) return;
    var from = img.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    var clone = img.cloneNode(true);
    clone.style.cssText = 'position:fixed;z-index:9999;top:' + from.top + 'px;left:' + from.left + 'px;width:' + from.width + 'px;height:' + from.height + 'px;border-radius:12px;object-fit:contain;padding:8px;background:rgb(var(--color-card));box-shadow:0 8px 32px rgba(0,0,0,0.2);transition:transform 0.7s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.7s;pointer-events:none;';
    document.body.appendChild(clone);
    /* Force reflow then animate */
    void clone.offsetWidth;
    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
    clone.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.15)';
    clone.style.opacity = '0.1';
    setTimeout(function() { if (clone.parentNode) clone.parentNode.removeChild(clone); }, 720);
  }
})();

/* === Hero Carousel — true seamless infinite loop (cloned edge slides) === */
(function() {
  document.querySelectorAll('[data-hero-carousel]').forEach(function(container) {
    var track = container.querySelector('[data-carousel-track]');
    var wrapper = container.closest('.hero-section__inner') || container.parentElement;
    var dots = wrapper.querySelectorAll('[data-carousel-dot]');
    if (!track) return;
    var realSlides = Array.prototype.slice.call(track.children);
    var n = realSlides.length;
    if (n < 2) return;

    /* Clone last slide at the start, and first slide at the end */
    var firstClone = realSlides[0].cloneNode(true);
    var lastClone = realSlides[n - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.setAttribute('data-clone', 'first');
    lastClone.setAttribute('data-clone', 'last');
    track.appendChild(firstClone);
    track.insertBefore(lastClone, track.firstChild);

    /* Logical index: 1..n map to real slides, 0 = lastClone, n+1 = firstClone */
    var index = 1;
    var DURATION = 550;
    var TRANS = 'transform ' + DURATION + 'ms cubic-bezier(0.22, 1, 0.36, 1)';
    track.style.transition = TRANS;
    track.style.transform = 'translateX(-' + (index * 100) + '%)';

    var startX = 0, startY = 0;
    var isDragging = false;
    var dragAxis = null; /* 'x' | 'y' | null */
    var autoTimer;
    var animating = false;

    function setDots() {
      var real = ((index - 1) % n + n) % n;
      dots.forEach(function(d, i) { d.classList.toggle('active', i === real); });
    }

    function snapAfterTransition() {
      /* When we animated onto a clone, jump (no transition) to the real slide */
      if (index === 0) {
        track.style.transition = 'none';
        index = n;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        /* Force reflow so the next transition is seen */
        void track.offsetWidth;
        track.style.transition = TRANS;
      } else if (index === n + 1) {
        track.style.transition = 'none';
        index = 1;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        void track.offsetWidth;
        track.style.transition = TRANS;
      }
      animating = false;
    }
    track.addEventListener('transitionend', snapAfterTransition);

    function goNext() {
      if (animating) return;
      animating = true;
      index++;
      track.style.transition = TRANS;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      setDots();
    }
    function goPrev() {
      if (animating) return;
      animating = true;
      index--;
      track.style.transition = TRANS;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      setDots();
    }
    function goToReal(realIdx) {
      if (animating) return;
      animating = true;
      index = realIdx + 1;
      track.style.transition = TRANS;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      setDots();
    }

    /* Touch */
    track.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true; dragAxis = null;
      clearInterval(autoTimer);
    }, { passive: true });
    track.addEventListener('touchmove', function(e) {
      if (!isDragging || dragAxis) return;
      var dx = Math.abs(e.touches[0].clientX - startX);
      var dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > 8 || dy > 8) dragAxis = dx > dy ? 'x' : 'y';
    }, { passive: true });
    track.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      var diff = startX - e.changedTouches[0].clientX;
      if (dragAxis === 'x' && Math.abs(diff) > 40) {
        if (diff > 0) goNext(); else goPrev();
      }
      startAutoAdvance();
    });

    /* Mouse */
    track.addEventListener('mousedown', function(e) {
      startX = e.clientX; isDragging = true;
      clearInterval(autoTimer); track.style.cursor = 'grabbing';
      e.preventDefault();
    });
    document.addEventListener('mouseup', function(e) {
      if (!isDragging) return;
      isDragging = false; track.style.cursor = '';
      var diff = startX - e.clientX;
      if (Math.abs(diff) > 50) { if (diff > 0) goNext(); else goPrev(); }
      startAutoAdvance();
    });

    /* Dots */
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        goToReal(i);
        clearInterval(autoTimer);
        startAutoAdvance();
      });
    });

    function startAutoAdvance() {
      clearInterval(autoTimer);
      autoTimer = setInterval(goNext, 6000);
    }
    startAutoAdvance();

    /* Pause when tab is hidden to avoid a jump when coming back */
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) clearInterval(autoTimer);
      else startAutoAdvance();
    });
  });
})();

/* === Unified Drag + Swipe with Click Prevention === */
(function() {
  /* Detect real mouse (no touch screen) — touch devices rely on native overflow scroll. */
  var hasTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

  document.querySelectorAll('[data-scroll-container]').forEach(function(container) {
    /* --- Shared state --- */
    var dragged = false;

    /* --- MOUSE: Momentum drag (desktop) --- */
    var isDown = false, startX, scrollLeft, lastX, lastTime, velocity, animFrame;

    function stopMomentum() { if (animFrame) cancelAnimationFrame(animFrame); }

    function applyMomentum() {
      if (Math.abs(velocity) < 0.5) return;
      container.scrollLeft -= velocity;
      velocity *= 0.95;
      animFrame = requestAnimationFrame(applyMomentum);
    }

    container.addEventListener('mousedown', function(e) {
      /* If this mousedown was synthesized from a touch, skip — let native scroll handle it. */
      if (hasTouch && e.pointerType === 'touch') return;
      stopMomentum();
      isDown = true;
      dragged = false;
      container.style.cursor = 'grabbing';
      startX = e.pageX;
      scrollLeft = container.scrollLeft;
      lastX = e.pageX;
      lastTime = Date.now();
      velocity = 0;
      e.preventDefault();
    });

    container.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX;
      var totalDx = Math.abs(x - startX);
      if (totalDx > 5) dragged = true; /* flag: this was a drag, not a click */
      container.scrollLeft = scrollLeft - (x - startX);
      var now = Date.now();
      var dt = now - lastTime;
      if (dt > 0) {
        var instant = (x - lastX) / dt * 16; /* normalize to ~60fps */
        /* Low-pass filter — new samples weighted 0.7, old 0.3. Kills stale velocity naturally. */
        velocity = instant * 0.7 + velocity * 0.3;
      }
      lastX = x;
      lastTime = now;
    });

    function mouseRelease() {
      if (!isDown) return;
      isDown = false;
      container.style.cursor = '';
      /* If user held still before releasing, kill stale velocity */
      var idle = Date.now() - lastTime;
      if (idle > 80) velocity = 0;
      if (Math.abs(velocity) > 1) applyMomentum();
    }

    container.addEventListener('mouseup', mouseRelease);
    container.addEventListener('mouseleave', mouseRelease);

    /* --- TOUCH: Swipe detection (mobile) --- */
    var touchStartX = 0, touchStartY = 0;

    container.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      dragged = false;
    }, { passive: true });

    container.addEventListener('touchmove', function(e) {
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      if (dx > 10 && dx > dy) dragged = true;
    }, { passive: true });

    /* --- CLICK PREVENTION: Works for both mouse AND touch --- */
    container.addEventListener('click', function(e) {
      if (dragged) {
        e.preventDefault();
        e.stopPropagation();
        dragged = false;
      }
    }, true); /* capture phase = runs before any <a> click handlers */
  });
})();

/* === Scroll Arrow Buttons === */
(function() {
  document.querySelectorAll('[data-scroll-prev], [data-scroll-next]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrap = btn.closest('.scroll-wrap');
      if (!wrap) return;
      var container = wrap.querySelector('[data-scroll-container]');
      if (!container) return;
      var dir = btn.hasAttribute('data-scroll-prev') ? -1 : 1;
      container.scrollBy({ left: dir * 300, behavior: 'smooth' });
    });
  });
})();

/* === Brand Showcase Tab Switching (legacy) === */
(function() {
  document.addEventListener('click', function(e) {
    var tab = e.target.closest('[data-brand-tab]');
    if (!tab) return;
    var block = tab.closest('.brand-showcase__block');
    if (!block) return;
    var handle = tab.getAttribute('data-brand-tab');
    block.querySelectorAll('[data-brand-tab]').forEach(function(t) { t.classList.toggle('active', t === tab); });
    block.querySelectorAll('[data-brand-panel]').forEach(function(panel) { panel.style.display = panel.getAttribute('data-brand-panel') === handle ? 'block' : 'none'; });
  });
})();

/* === Collection Tabs Switching + Pill Strip Swipe ===
   Touch: fully native via `overflow-x: auto` + `-webkit-overflow-scrolling: touch`.
   A JS touchmove+preventDefault handler KILLS iOS native momentum scroll, so we
   deliberately attach NO touch listeners to the pill strip.
   Mouse: hold-drag scrolls the strip on desktop.
   Click suppression: a capture-phase guard kills the phantom click that fires
   at the end of a mouse drag AND the click that fires at the end of a native
   scroll (via scroll timestamp). */
(function() {
  document.querySelectorAll('[data-collection-tabs]').forEach(function(section) {
    var pills = section.querySelectorAll('[data-tab-btn]');
    var panels = section.querySelectorAll('[data-tab-panel]');
    var pillStrip = section.querySelector('.collection-tabs__pills');
    if (pills.length === 0) return;

    /* Shared suppression flags */
    var mouseDragged = false;
    var lastScrollAt = 0;

    pills.forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        if (mouseDragged || (Date.now() - lastScrollAt) < 120) {
          e.preventDefault();
          e.stopPropagation();
          mouseDragged = false;
          return;
        }
        var id = pill.getAttribute('data-tab-btn');
        pills.forEach(function(p) { p.classList.toggle('active', p === pill); });
        panels.forEach(function(panel) { panel.classList.toggle('active', panel.getAttribute('data-tab-panel') === id); });
        var headingEl = section.querySelector('[data-tabs-heading]');
        if (headingEl) headingEl.textContent = pill.textContent.trim();
      });
    });

    if (!pillStrip) return;

    /* Native scroll timestamp — any scroll (touch, trackpad, or wheel) marks
       a short suppression window so the next click isn't interpreted as tab. */
    pillStrip.addEventListener('scroll', function() { lastScrollAt = Date.now(); }, { passive: true });

    /* Mouse drag — desktop only. No touch events touched here. */
    var isDown = false, startX = 0, startScroll = 0;

    pillStrip.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      isDown = true;
      mouseDragged = false;
      startX = e.pageX;
      startScroll = pillStrip.scrollLeft;
      pillStrip.style.cursor = 'grabbing';
    });
    document.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 4) mouseDragged = true;
      pillStrip.scrollLeft = startScroll - dx;
    });
    document.addEventListener('mouseup', function() {
      if (!isDown) return;
      isDown = false;
      pillStrip.style.cursor = '';
    });

    /* Capture-phase click block — kills click fired at end of mouse drag or
       right after a native scroll. */
    pillStrip.addEventListener('click', function(e) {
      if (mouseDragged || (Date.now() - lastScrollAt) < 120) {
        e.preventDefault();
        e.stopPropagation();
        mouseDragged = false;
      }
    }, true);
  });
})();

/* === Search Overlay with Live Autocomplete === */
(function() {
  var overlay = document.getElementById('search-overlay');
  if (!overlay) return;
  var input = overlay.querySelector('.search-overlay__input');
  var resultsPanel = overlay.querySelector('#search-results');
  var list = overlay.querySelector('[data-search-list]');
  var footer = overlay.querySelector('[data-search-footer]');
  var form = overlay.querySelector('form');
  var debounceTimer = null;
  var lastQ = '';

  window.openSearch = function() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (input) setTimeout(function() { input.focus(); }, 50);
  };
  window.closeSearch = function() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  document.querySelectorAll('[data-search-open]').forEach(function(btn) {
    btn.addEventListener('click', function(e) { e.preventDefault(); window.openSearch(); });
  });
  var closeBtn = overlay.querySelector('[data-search-close]');
  if (closeBtn) closeBtn.addEventListener('click', window.closeSearch);
  var backdrop = overlay.querySelector('.search-overlay__backdrop');
  if (backdrop) backdrop.addEventListener('click', window.closeSearch);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) window.closeSearch();
  });

  function renderResults(data, q) {
    if (!data || !data.resources || !data.resources.results) { renderEmpty(q); return; }
    var products = data.resources.results.products || [];
    var collections = data.resources.results.collections || [];
    if (!products.length && !collections.length) { renderEmpty(q); return; }

    var html = '';
    collections.slice(0, 3).forEach(function(c) {
      html += '<a href="' + c.url + '" class="search-overlay__item" role="option">' +
        '<div class="search-overlay__item-img" style="display:flex;align-items:center;justify-content:center;color:rgb(var(--color-muted));font-size:.7rem;">COL</div>' +
        '<div class="search-overlay__item-body">' +
        '<p class="search-overlay__item-title">' + escapeHtml(c.title) + '</p>' +
        '<p class="search-overlay__item-vendor">Collection</p>' +
        '</div></a>';
    });
    products.slice(0, 8).forEach(function(p) {
      var img = p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '';
      html += '<a href="' + p.url + '" class="search-overlay__item" role="option">' +
        '<div class="search-overlay__item-img">' + img + '</div>' +
        '<div class="search-overlay__item-body">' +
        '<p class="search-overlay__item-title">' + escapeHtml(p.title) + '</p>' +
        (p.vendor ? '<p class="search-overlay__item-vendor">' + escapeHtml(p.vendor) + '</p>' : '') +
        '</div>' +
        (p.price ? '<div class="search-overlay__item-price">' + p.price + '</div>' : '') +
        '</a>';
    });
    list.innerHTML = html;
    footer.innerHTML = 'Press <strong>Enter</strong> to see all results for "<a href="/search?q=' + encodeURIComponent(q) + '">' + escapeHtml(q) + '</a>"';
    resultsPanel.hidden = false;
  }

  function renderEmpty(q) {
    list.innerHTML = '<div class="search-overlay__empty">No results for "' + escapeHtml(q) + '"</div>';
    footer.innerHTML = 'Try different keywords or <a href="/collections/all">browse all products</a>';
    resultsPanel.hidden = false;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function doSearch(q) {
    if (!q || q.length < 2) { resultsPanel.hidden = true; list.innerHTML = ''; return; }
    if (q === lastQ) return;
    lastQ = q;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,body';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(data) { renderResults(data, q); })
      .catch(function() { renderEmpty(q); });
  }

  if (input) {
    input.addEventListener('input', function() {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() { doSearch(q); }, 220);
    });
  }

  /* Enter key in input: submit form to /search page (natural form behavior) */
  /* Arrow keys navigate results, Enter goes to focused item */
  overlay.addEventListener('keydown', function(e) {
    var items = list.querySelectorAll('.search-overlay__item');
    if (!items.length) return;
    var active = list.querySelector('.is-active');
    var idx = Array.prototype.indexOf.call(items, active);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (active) active.classList.remove('is-active');
      items[Math.min(idx + 1, items.length - 1) || 0].classList.add('is-active');
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (active) active.classList.remove('is-active');
      items[Math.max(idx - 1, 0)].classList.add('is-active');
    } else if (e.key === 'Enter' && active) {
      e.preventDefault();
      window.location.href = active.getAttribute('href');
    }
  });
})();

/* === Product Variant Switching === */
(function() {
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form || !window.location.pathname.includes('/products/')) return;

  var radios = form.querySelectorAll('.product-variants__radio');
  var priceEl = document.querySelector('.product-info__price-current');
  var compareEl = document.querySelector('.product-info__price-compare');
  var idInput = form.querySelector('input[name="id"]');
  var atcBtn = form.querySelector('.product-form__atc');
  var mainImg = document.getElementById('main-product-img');

  var productJson = null;
  var jsonEl = document.getElementById('product-json');
  if (jsonEl) { try { productJson = JSON.parse(jsonEl.textContent); } catch(e) {} }

  if (!productJson || !radios.length) return;

  function getSelectedOptions() {
    var opts = [];
    form.querySelectorAll('fieldset').forEach(function(fs) {
      var checked = fs.querySelector('.product-variants__radio:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }

  function findVariant(opts) {
    return productJson.variants.find(function(v) {
      return v.options.every(function(o, i) { return o === opts[i]; });
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  radios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      var opts = getSelectedOptions();
      var variant = findVariant(opts);
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (mainImg && variant.featured_image) {
        mainImg.src = variant.featured_image.src;
      }

      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    });
  });
})();

/* === AJAX Collection Switching — prefetch + in-memory cache for instant swaps === */
(function() {
  var nav = document.querySelector('[data-collection-nav]');
  var content = document.querySelector('[data-collection-content]');
  if (!nav || !content) return;

  var loading = false;
  var cache = Object.create(null);   /* url -> { html, title } */
  var inflight = Object.create(null); /* url -> Promise */

  function normalize(url) {
    try { return new URL(url, window.location.origin).pathname + new URL(url, window.location.origin).search; }
    catch (e) { return url; }
  }

  function setActive(url) {
    var u = normalize(url);
    nav.querySelectorAll('.collection-nav__card').forEach(function(card) {
      var href = card.getAttribute('href');
      var match = href && u.indexOf(normalize(href)) === 0;
      card.classList.toggle('collection-nav__card--active', !!match);
    });
  }

  function fetchInto(url) {
    var key = normalize(url);
    if (cache[key]) return Promise.resolve(cache[key]);
    if (inflight[key]) return inflight[key];
    inflight[key] = fetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-collection-content]');
        var entry = {
          html: fresh ? fresh.innerHTML : null,
          title: doc.title || document.title
        };
        if (entry.html) cache[key] = entry;
        delete inflight[key];
        return entry;
      })
      .catch(function(err) {
        delete inflight[key];
        throw err;
      });
    return inflight[key];
  }

  function render(entry, url, push) {
    if (!entry || !entry.html) { window.location.href = url; return; }
    content.innerHTML = entry.html;
    document.title = entry.title;
    if (push) window.history.pushState({ collectionUrl: url }, '', url);
    setActive(url);
    var navTop = nav.getBoundingClientRect().top + window.scrollY - 80;
    if (window.scrollY > navTop) window.scrollTo({ top: navTop, behavior: 'smooth' });
  }

  function swap(url, push) {
    if (loading) return;
    var key = normalize(url);
    if (cache[key]) {
      /* Instant render from cache */
      render(cache[key], url, push);
      return;
    }
    loading = true;
    content.style.opacity = '0.6';
    content.style.pointerEvents = 'none';
    fetchInto(url)
      .then(function(entry) { render(entry, url, push); })
      .catch(function() { window.location.href = url; })
      .then(function() {
        content.style.opacity = '';
        content.style.pointerEvents = '';
        loading = false;
      });
  }

  /* Prefetch the current collection into cache so back/forward are instant */
  (function seedCurrent() {
    var curr = window.location.pathname + window.location.search;
    cache[normalize(curr)] = { html: content.innerHTML, title: document.title };
  })();

  /* Prefetch all nav collections in the background (idle + sequentially) */
  function idlePrefetchAll() {
    var links = [];
    nav.querySelectorAll('.collection-nav__card').forEach(function(a) {
      var href = a.getAttribute('href');
      if (href && !cache[normalize(href)]) links.push(href);
    });
    var queue = links.slice();
    function next() {
      if (!queue.length) return;
      var url = queue.shift();
      fetchInto(url).then(function() {
        if (window.requestIdleCallback) requestIdleCallback(next, { timeout: 1500 });
        else setTimeout(next, 400);
      }).catch(next);
    }
    if (window.requestIdleCallback) requestIdleCallback(next, { timeout: 2000 });
    else setTimeout(next, 800);
  }
  idlePrefetchAll();

  /* Hover / touchstart prefetch for near-instant feel */
  nav.addEventListener('mouseover', function(e) {
    var card = e.target.closest('.collection-nav__card');
    if (!card) return;
    var href = card.getAttribute('href');
    if (href) fetchInto(href).catch(function(){});
  });
  nav.addEventListener('touchstart', function(e) {
    var card = e.target.closest('.collection-nav__card');
    if (!card) return;
    var href = card.getAttribute('href');
    if (href) fetchInto(href).catch(function(){});
  }, { passive: true });

  /* Intercept clicks on nav cards */
  nav.addEventListener('click', function(e) {
    var card = e.target.closest('.collection-nav__card');
    if (!card) return;
    var href = card.getAttribute('href');
    if (!href) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    swap(href, true);
  });

  /* Intercept pagination + sort select inside the content area */
  content.addEventListener('click', function(e) {
    var link = e.target.closest('.coll-pagination a');
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    swap(link.getAttribute('href'), true);
  });

  content.addEventListener('change', function(e) {
    if (e.target && e.target.id === 'sort-select') {
      swap(e.target.value, true);
    }
  });

  /* Back / forward */
  window.addEventListener('popstate', function() {
    swap(window.location.href, false);
  });
})();

/* === SafeWake Product Page Recommendation Engine ===
   Powers: Complete Your Setup (smart cross-sell), You May Also Like
   (infinite scroll + variety), Frequently Bought Together (mini-bundle). */
(function() {
  function norm(s) { return (s || '').toString().toLowerCase(); }

  /* Vendor-aware categorize — uses vendor (hard signal) THEN type (soft signal).
     SafeWake catalog: Hyperlite = wake, HO Sports = ski, Bataleon/Rome = snow.
     Sports are strictly partitioned — never cross-pollinate wake/ski/snow.
     Order of checks matters: specific subtypes (bag/rope/accessory) MUST
     come before the generic 'wake|board|boat|cable' fallback. */
  function categorize(p) {
    if (!p) return null;
    var v = norm(p.vendor).replace(/^\d{4}\s*/, '');
    var t = norm(p.product_type || p.type).replace(/^\d{4}\s*/, '');
    var sport =
      /bataleon|rome/.test(v) ? 'snow' :
      /hyperlite/.test(v)     ? 'wake' :
      /ho\s*sports/.test(v)   ? 'ski'  :
      /sandbox/.test(v)       ? 'helmet' :
      /heyday/.test(v)        ? 'boat' : '';
    /* Vendor unknown — sniff from type */
    if (!sport) {
      if (/snow/.test(t))                     sport = 'snow';
      else if (/wake|foil|tube|surf/.test(t)) sport = 'wake';
      else if (/\bski\b/.test(t))             sport = 'ski';
    }
    if (sport === 'wake') {
      /* Specific subtypes first — must precede generic wake/board regex */
      if (/bag/.test(t))                           return 'wake_bag';
      if (/rope/.test(t))                          return 'wake_rope';
      if (/vest|pfd|jacket|comp/.test(t))          return 'wake_vest';
      if (/accessor/.test(t))                      return 'wake_accessory';
      if (/binding/.test(t))                       return 'wake_binding';
      if (/knee/.test(t))                          return 'kneeboard';
      if (/surf/.test(t))                          return 'wake_surf';
      if (/tube/.test(t))                          return 'wake_tube';
      if (/foil/.test(t))                          return 'wake_foil';
      if (/paddle/.test(t))                        return 'paddleboard';
      if (/apparel|boardshort|rash/.test(t))       return 'wake_apparel';
      if (/wake|board|boat|cable/.test(t))         return 'wake_board';
      return 'wake_other';
    }
    if (sport === 'ski') {
      if (/bag/.test(t))                           return 'ski_bag';
      if (/rope/.test(t))                          return 'ski_rope';
      if (/vest|pfd|jacket/.test(t))               return 'wake_vest'; /* HO vests cross-sport */
      if (/glove|wetsuit|westuit/.test(t))         return 'ski_glove';
      if (/boot|binding/.test(t))                  return 'ski_boot';
      if (/accessor/.test(t))                      return 'ski_accessory';
      if (/apparel/.test(t))                       return 'ski_apparel';
      if (/ski/.test(t))                           return 'waterski';
      return 'ski_other';
    }
    if (sport === 'snow') {
      if (/bag/.test(t))                           return 'snow_bag';
      if (/boot/.test(t))                          return 'snow_boot';
      if (/binding/.test(t))                       return 'snow_binding';
      if (/accessor/.test(t))                      return 'snow_accessory';
      if (/apparel/.test(t))                       return 'snow_apparel';
      return 'snowboard';
    }
    if (sport === 'helmet') return 'helmet';
    if (sport === 'boat')   return 'wake_accessory';
    return null;
  }

  /* Cross-sell map — tuned for maximum relevant upsell.
     Rules:
       1. Same-sport islands only (wake/ski/snow never cross)
       2. Every category points to complementary items — never itself
       3. Wakeboards, wakesurfs, waterskis always include a bag to upsell
       4. Primary gear (board/ski) leads with binding → vest → rope → bag → accessory
       5. Secondary items (bag/rope/accessory) point back to the primary board
       6. Vests are universal cross-sport (wake ↔ surf ↔ waterski)
  */
  var CROSS_SELL = {
    /* Wake ecosystem — wakeboard is the anchor item; cast widest net (CRO audit:
       maximize AOV with bag + apparel + kneeboard + helmet in addition to core). */
    wake_board:     ['wake_binding', 'wake_vest', 'wake_rope', 'wake_bag', 'wake_apparel', 'helmet', 'kneeboard', 'wake_accessory'],
    wake_binding:   ['wake_board', 'wake_vest', 'wake_bag', 'wake_rope', 'wake_apparel'],
    wake_surf:      ['wake_vest', 'wake_rope', 'wake_bag', 'wake_accessory'],
    wake_vest:      ['wake_board', 'wake_surf', 'waterski', 'wake_rope'],
    wake_tube:      ['wake_rope', 'wake_vest', 'wake_accessory'],
    wake_foil:      ['wake_vest', 'wake_rope', 'wake_bag'],
    wake_rope:      ['wake_board', 'wake_binding', 'wake_vest'],
    wake_bag:       ['wake_board', 'wake_binding', 'wake_vest'],
    wake_accessory: ['wake_board', 'wake_binding', 'wake_vest', 'wake_bag'],
    wake_apparel:   ['wake_board', 'wake_binding', 'wake_vest'],
    kneeboard:      ['wake_vest', 'wake_rope', 'wake_accessory'],
    paddleboard:    ['wake_vest', 'wake_accessory'],
    /* Ski ecosystem */
    waterski:       ['ski_boot', 'wake_vest', 'ski_rope', 'ski_glove', 'ski_bag'],
    ski_boot:       ['waterski', 'wake_vest', 'ski_rope', 'ski_glove'],
    ski_rope:       ['waterski', 'ski_boot', 'wake_vest'],
    ski_bag:        ['waterski', 'ski_boot'],
    ski_glove:      ['waterski', 'ski_boot'],
    ski_accessory:  ['waterski', 'ski_boot', 'ski_rope'],
    ski_apparel:    ['waterski', 'ski_boot'],
    /* Snow ecosystem */
    snowboard:      ['snow_binding', 'snow_boot', 'snow_bag', 'snow_apparel'],
    snow_binding:   ['snowboard', 'snow_boot', 'snow_bag'],
    snow_boot:      ['snowboard', 'snow_binding', 'snow_bag'],
    snow_bag:       ['snowboard', 'snow_binding'],
    snow_accessory: ['snowboard', 'snow_binding'],
    snow_apparel:   ['snowboard'],
    /* Other */
    helmet:         ['wake_board', 'wake_binding', 'wake_vest']
  };

  /* Filter: in-stock AND priced > 0. Handles BOTH /products.json format
     (price inside variants[]) AND Ajax API format (top-level price_min).
     Blocks the ~70% zero-priced catalog rows from every carousel. */
  function isShowable(p) {
    if (!p) return false;
    /* /products.json shape: variants[] each with { price: "179.66", available: true } */
    if (p.variants && p.variants.length) {
      return p.variants.some(function(v) {
        if (v.available === false) return false;
        var price = parseFloat(v.price);
        return isFinite(price) && price > 0;
      });
    }
    /* Ajax API / recommendations API shape: top-level price_min + available */
    if (p.available === false) return false;
    var price = (p.price_min != null ? p.price_min : p.price);
    var num = typeof price === 'number' ? price
            : typeof price === 'string' ? parseFloat(price) : NaN;
    if (!isFinite(num) || num <= 0) return false;
    return true;
  }

  /* Back-compat shim — old call sites still pass (type, tags) without vendor.
     Only used as a fallback if a caller lacks product vendor info. */
  function detectCategory(type, tags, vendor) {
    return categorize({ product_type: type, tags: tags || [], vendor: vendor || '' });
  }

  /* Global store cache — avoid refetching /products.json on same page */
  var storeCache = { products: [], exhaustedPage: null, loadedPages: {} };

  function fetchStorePage(page) {
    if (storeCache.loadedPages[page]) return Promise.resolve([]);
    storeCache.loadedPages[page] = true;
    return fetch('/products.json?limit=50&page=' + page + '&sort_by=best-selling', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var arr = (data && data.products) || [];
        if (!arr.length) storeCache.exhaustedPage = page;
        /* Drop zero-price + sold-out at the source so every downstream carousel is clean */
        var filtered = arr.filter(isShowable);
        storeCache.products = storeCache.products.concat(filtered);
        return filtered;
      })
      .catch(function() { storeCache.exhaustedPage = page; return []; });
  }

  /* Shared horizontal infinite scroller. `loader` returns a Promise resolving to `true` when exhausted. */
  function makeInfiniteScroller(container, loader, opts) {
    opts = opts || {};
    var prefetch = opts.prefetch != null ? opts.prefetch : 300;
    var loading = false, done = false;
    function tick() {
      if (loading || done) return;
      if (container.scrollLeft + container.clientWidth > container.scrollWidth - prefetch) {
        loading = true;
        Promise.resolve(loader()).then(function(exhausted) {
          loading = false;
          if (exhausted) done = true;
        }).catch(function() { loading = false; });
      }
    }
    container.addEventListener('scroll', tick, { passive: true });
    setTimeout(tick, 120);
    return { refresh: tick };
  }

  function formatPriceCents(cents) {
    return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' AED';
  }

  function extractImage(p) {
    var img = p.featured_image || (p.images && p.images[0]) || (p.image && p.image.src) || '';
    if (img && typeof img === 'object') img = img.src;
    if (img && img.indexOf('http') === 0 && img.indexOf('width=') === -1) {
      img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    }
    return img || '';
  }

  function escAttr(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }
  function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
  }); }

  function priceText(p) {
    /* Derive price from the first available variant for /products.json shape,
       then fall back to top-level for Ajax/recs API. Without this, wakeboard
       cards fetched from /products.json would all display as "0.000 AED".
       P29 FIX: removed the cents>1000 branch — priceText is ONLY called on
       /products.json products which are ALWAYS decimal, never cents. The old
       heuristic broke on prices between 10-999 KWD. */
    var priceVal = null;
    if (p.variants && p.variants.length) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (v && v.available !== false && v.price != null) { priceVal = v.price; break; }
      }
      if (priceVal == null && p.variants[0] != null) priceVal = p.variants[0].price;
    }
    if (priceVal == null) priceVal = (p.price != null ? p.price : p.price_min);
    if (typeof priceVal === 'string' && /[A-Z]/.test(priceVal)) return priceVal;
    var num = parseFloat(priceVal);
    return (isNaN(num) || num <= 0) ? '' : num.toFixed(2) + ' AED';
  }

  function recCardHtml(p) {
    var url = p.url || ('/products/' + p.handle);
    var img = extractImage(p);
    var imgHtml = img
      ? '<img src="' + escAttr(img) + '" alt="' + escAttr(p.title) + '" loading="lazy" style="width:100%;height:100%;object-fit:contain;padding:8px;">'
      : '';
    var tagsStr = (p.tags || []).map(norm).join(',');
    var express = tagsStr.indexOf('locally stored') >= 0
      ? '<div class="product-badges"><span class="badge-express"><svg viewBox="0 0 24 24" aria-hidden="true"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>Express</span></div>'
      : '';
    var type = escAttr(p.product_type || p.type || '');
    return '<a href="' + escAttr(url) + '" class="rec-card" data-rec-type="' + type + '" style="flex-shrink:0;width:160px;text-decoration:none;color:inherit;">' +
      '<div class="rec-card__img" style="aspect-ratio:1;border-radius:12px;overflow:hidden;background:transparent;position:relative;">' +
      imgHtml + express + '</div>' +
      '<p style="font-size:0.6875rem;color:rgb(var(--color-muted));margin:6px 0 2px;">' + escHtml(p.vendor || '') + '</p>' +
      '<p style="font-size:0.8125rem;font-weight:500;margin:0 0 4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escHtml(p.title) + '</p>' +
      '<p style="font-size:0.8125rem;margin:0;">' + escHtml(priceText(p)) + '</p>' +
      '</a>';
  }

  function bundleCardHtml(p) {
    var url = p.url || ('/products/' + p.handle);
    var img = extractImage(p);
    var imgHtml = img
      ? '<img src="' + escAttr(img) + '" alt="' + escAttr(p.title) + '" loading="lazy" width="140" height="140">'
      : '';
    var variantId = p.variants && p.variants[0] && p.variants[0].id;
    var available = p.available !== false && variantId;
    var soldoutTxt = 'Sold out';
    var addPrefix = 'Add';
    var priceShort = priceText(p).replace(' AED', '');
    var addBtn = available
      ? '<form action="/cart/add" method="post" class="bundle-card__form">' +
        '<input type="hidden" name="id" value="' + variantId + '">' +
        '<button type="submit" class="bundle-card__add" aria-label="Add to cart">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
        '<span data-i18n="products.bundle.add_prefix">' + escHtml(addPrefix) + '</span> · ' + escHtml(priceShort) + '</button></form>'
      : '<span class="bundle-card__soldout" data-i18n="products.sold_out">' + escHtml(soldoutTxt) + '</span>';
    return '<div class="bundle-card">' +
      '<a href="' + escAttr(url) + '" class="bundle-card__link">' +
      '<div class="bundle-card__img">' + imgHtml + '</div>' +
      '<p class="bundle-card__vendor">' + escHtml(p.vendor || '') + '</p>' +
      '<p class="bundle-card__title">' + escHtml((p.title || '').substr(0, 30)) + '</p>' +
      '</a>' + addBtn + '</div>';
  }

  /* ===== COMPLETE YOUR SETUP — Smart Cross-Sell + Infinite Scroll ===== */
  (function completeSetup() {
    var section = document.querySelector('[data-complete-setup]');
    if (!section) return;
    var track = section.querySelector('[data-complete-setup-track]');
    if (!track) return;
    var currentHandle = section.getAttribute('data-product-handle');
    var source = {
      handle: currentHandle,
      vendor: section.getAttribute('data-product-vendor') || '',
      product_type: section.getAttribute('data-product-type') || '',
      tags: (section.getAttribute('data-product-tags') || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean)
    };
    var srcCat = categorize(source);
    if (!srcCat) return;
    var wantedCats = CROSS_SELL[srcCat] || [];
    if (!wantedCats.length) return;
    var wantedSet = {}; wantedCats.forEach(function(c) { wantedSet[c] = true; });

    var shown = {};
    shown[currentHandle] = true;
    var lastCat = null, sameRun = 0;
    var page = 1;

    function renderPicks(products) {
      if (!products || !products.length) return 0;
      var appended = 0;
      /* Interleave by category so we don't dump 6 bindings before the first vest */
      var byCat = {};
      products.forEach(function(p) {
        if (!p || !p.handle || shown[p.handle]) return;
        if (!isShowable(p)) return;
        var cat = categorize(p);
        if (!cat || !wantedSet[cat]) return;
        (byCat[cat] = byCat[cat] || []).push(p);
      });
      var cats = Object.keys(byCat);
      if (!cats.length) return 0;
      var maxLen = cats.reduce(function(m, c) { return Math.max(m, byCat[c].length); }, 0);
      var queue = [];
      for (var i = 0; i < maxLen; i++) {
        cats.forEach(function(c) { if (byCat[c][i]) queue.push(byCat[c][i]); });
      }
      queue.forEach(function(p) {
        if (shown[p.handle]) return;
        var cat = categorize(p);
        if (cat === lastCat) {
          sameRun++;
          if (sameRun >= 3) return; /* Variety gate */
        } else {
          sameRun = 0; lastCat = cat;
        }
        track.insertAdjacentHTML('beforeend', bundleCardHtml(p));
        shown[p.handle] = true;
        appended++;
      });
      return appended;
    }

    function loader() {
      /* Try cached products first */
      if (storeCache.products.length) {
        var added = renderPicks(storeCache.products);
        if (added > 0) {
          notifyCardsRendered();
          return Promise.resolve(false);
        }
      }
      /* Fetch next page */
      if (storeCache.exhaustedPage && page > storeCache.exhaustedPage) return Promise.resolve(true);
      return fetchStorePage(page).then(function(arr) {
        page++;
        var added = renderPicks(arr);
        if (added > 0) notifyCardsRendered();
        if (added === 0 && (storeCache.exhaustedPage || arr.length === 0)) return true;
        return false;
      });
    }

    function notifyCardsRendered() {
      window.dispatchEvent(new CustomEvent('sw:cards-rendered', { detail: { scope: track } }));
    }

    /* Init — smart picks only. If smart engine finds 0 complementary products,
       hide the section entirely. We never fall back to same-collection products
       (which on a wakeboard PDP would show more wakeboards — the exact bug the
       founder flagged). */
    fetchStorePage(1).then(function(){ return fetchStorePage(2); }).then(function() {
      var liquidSeedCount = track.children.length;
      renderPicks(storeCache.products);
      var smartCount = track.children.length - liquidSeedCount;
      if (smartCount >= 1) {
        /* Remove Liquid-seeded cards — smart picks now populate */
        for (var i = 0; i < liquidSeedCount; i++) {
          if (track.firstChild) track.removeChild(track.firstChild);
        }
        section.hidden = false; /* P29: reveal after JS populates with complementary products */
        makeInfiniteScroller(track, loader);
      } else {
        /* Smart engine found nothing — hide the whole CYS section rather than
           show misleading same-collection products. */
        section.hidden = true;
      }
    });
  })();

  /* ===== FREQUENTLY BOUGHT TOGETHER ===== */
  (function fbt() {
    var section = document.querySelector('[data-product-fbt]');
    if (!section) return;
    var row = section.querySelector('[data-fbt-row]');
    var totalEl = section.querySelector('[data-fbt-total]');
    var saveEl = section.querySelector('[data-fbt-save]');
    var addAllBtn = section.querySelector('[data-fbt-add-all]');
    var productJsonEl = document.getElementById('product-json');
    if (!row || !productJsonEl) return;

    var current;
    try { current = JSON.parse(productJsonEl.textContent); } catch (e) { return; }
    var srcCat = categorize({
      vendor: current.vendor,
      product_type: current.type || current.product_type,
      tags: current.tags
    });
    if (!srcCat) return;
    var wantedCats = CROSS_SELL[srcCat] || [];
    if (!wantedCats.length) return;

    function pick2(products) {
      /* Pick exactly ONE product per wanted category (max 2 total).
         Bug fix: previous version didn't break after first match per category,
         so two "Wake Binding" products (a binding + a system boot both typed
         as Wake Binding) would both get picked — showing binding+boot which
         don't go together. Now each category gets at most 1 pick. */
      var picked = [];
      var seen = {};
      seen[current.handle] = true;
      for (var i = 0; i < wantedCats.length && picked.length < 2; i++) {
        var cat = wantedCats[i];
        for (var j = 0; j < products.length; j++) {
          var p = products[j];
          if (seen[p.handle]) continue;
          if (!isShowable(p)) continue;
          var bv = bestVariant(p);
          if (!bv || toKWD(bv.price, false) <= 0) continue;
          var pcat = categorize(p);
          if (pcat !== cat) continue;
          picked.push(p); seen[p.handle] = true;
          break; /* ONE per category — move to next wantedCat */
        }
      }
      return picked;
    }

    /* Find the FIRST available non-zero-priced variant for a product.
       Fix: variants[0] is often a zero-price or sold-out variant in this catalog
       (~70% of variants are priced 0). This caused FBT to display "0.000 AED". */
    function bestVariant(prod) {
      if (!prod.variants || !prod.variants.length) return null;
      for (var i = 0; i < prod.variants.length; i++) {
        var v = prod.variants[i];
        if (v.available !== false && parseFloat(v.price) > 0) return v;
      }
      for (var j = 0; j < prod.variants.length; j++) {
        if (parseFloat(prod.variants[j].price) > 0) return prod.variants[j];
      }
      return prod.variants[0];
    }

    /* Normalize a variant price to KWD decimal — SOURCE-AWARE (P29 fix).
       - fromLiquid=true  → price is from Liquid JSON ({{ product | json }}) = integer cents → ALWAYS ÷100
       - fromLiquid=false → price is from /products.json Ajax = decimal string → NEVER ÷100
       The old >999 heuristic broke on cheap items (9.99 KWD = 999 cents → treated as decimal). */
    function toKWD(rawPrice, fromLiquid) {
      if (rawPrice == null) return 0;
      var n = parseFloat(rawPrice);
      if (!isFinite(n)) return 0;
      return fromLiquid ? n / 100 : n;
    }

    function fbtItemHtml(p, checked, isCurrent) {
      var img = extractImage(p);
      var imgHtml = img
        ? '<img src="' + escAttr(img) + '" alt="' + escAttr(p.title) + '" loading="lazy">'
        : '';
      var bv = isCurrent
        ? bestVariant(current) || (current.variants && current.variants[0])
        : bestVariant(p) || (p.variants && p.variants[0]);
      var variantId = bv ? bv.id : null;
      var priceKWD = bv ? toKWD(bv.price, isCurrent) : 0;
      var priceCents = Math.round(priceKWD * 100);
      var priceDisplay = priceKWD > 0 ? priceKWD.toFixed(2) + ' AED' : '';
      var checkLabelKey = isCurrent ? 'products.fbt.this_item' : 'products.fbt.include';
      var checkLabelEn  = isCurrent ? 'This item' : 'Include';
      var checkLabel    = checkLabelEn;
      return '<div class="product-fbt__item" data-fbt-item data-variant-id="' + escAttr(variantId) + '" data-price-cents="' + escAttr(priceCents) + '">' +
        '<div class="product-fbt__img">' + imgHtml + '</div>' +
        '<p class="product-fbt__title">' + escHtml((p.title || '').substr(0, 40)) + '</p>' +
        '<p class="product-fbt__price">' + escHtml(priceDisplay) + '</p>' +
        '<label class="product-fbt__check-row">' +
          '<input type="checkbox" class="product-fbt__check" data-fbt-check ' + (checked ? 'checked' : '') + ' ' + (isCurrent ? 'data-current' : '') + '>' +
          '<span class="product-fbt__check-label" data-i18n="' + checkLabelKey + '">' + escHtml(checkLabel) + '</span>' +
        '</label>' +
        '</div>';
    }

    function recalcTotal() {
      var cents = 0;
      row.querySelectorAll('[data-fbt-item]').forEach(function(it) {
        var cb = it.querySelector('[data-fbt-check]');
        if (cb && cb.checked) cents += parseInt(it.getAttribute('data-price-cents'), 10) || 0;
      });
      /* cents here = price * 100 (e.g. 71.130 KWD → 7113).
         formatPriceCents expects Shopify-style cents (÷100 to get KWD). */
      if (totalEl) totalEl.textContent = (cents / 100).toFixed(2) + ' AED';
    }

    function renderAll(picks) {
      var items = [current].concat(picks);
      var html = items.map(function(p, i) {
        return fbtItemHtml(p, true, i === 0) + (i < items.length - 1 ? '<span class="product-fbt__plus" aria-hidden="true">+</span>' : '');
      }).join('');
      row.innerHTML = html;
      recalcTotal();
      section.hidden = false;
      window.dispatchEvent(new CustomEvent('sw:cards-rendered', { detail: { scope: section } }));
    }

    row.addEventListener('change', function(e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-fbt-check')) recalcTotal();
    });

    if (addAllBtn) addAllBtn.addEventListener('click', function() {
      var items = [];
      row.querySelectorAll('[data-fbt-item]').forEach(function(it) {
        var cb = it.querySelector('[data-fbt-check]');
        if (!cb || !cb.checked) return;
        var vid = it.getAttribute('data-variant-id');
        if (vid && vid !== 'null' && vid !== 'undefined') items.push({ id: parseInt(vid, 10), quantity: 1 });
      });
      if (!items.length) return;
      addAllBtn.disabled = true;
      var originalText = addAllBtn.textContent;
      addAllBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function(r) { return r.json(); })
        .then(function() {
          return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(r) { return r.json(); })
        .then(function(sections) {
          if (sections && sections['cart-drawer']) {
            var wrap = document.createElement('div');
            wrap.innerHTML = sections['cart-drawer'];
            var fresh = wrap.querySelector('#cart-drawer');
            var existing = document.getElementById('cart-drawer');
            if (fresh && existing) existing.innerHTML = fresh.innerHTML;
          }
          return fetch('/cart.js').then(function(r) { return r.json(); });
        })
        .then(function(cart) {
          document.querySelectorAll('.header__cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
          if (window.swToast) window.swToast('Added to cart · ' + items.length + ' items · بكل بساطة');
          /* Drawer intentionally NOT auto-opened here — toast is the confirmation.
             User can click the cart icon to view. */
        })
        .catch(function() {
          if (window.swToast) window.swToast('Could not add all items', { variant: 'error' });
        })
        .then(function() {
          addAllBtn.disabled = false;
          addAllBtn.textContent = originalText;
        });
    });

    fetchStorePage(1).then(function() { return fetchStorePage(2); }).then(function() {
      var picks = pick2(storeCache.products);
      if (picks.length < 1) return; /* Hide if we can't find complements */
      renderAll(picks);
    });
  })();

  /* ===== YOU MAY ALSO LIKE — infinite scroll + variety enforcement ===== */
  (function ymal() {
    var container = document.querySelector('[data-infinite-scroll]');
    if (!container) return;
    var productId = container.getAttribute('data-product-id');
    var currentHandle = container.getAttribute('data-product-handle') || '';
    var loading = false;
    var exhausted = false;
    var page = 1;
    var seedDone = false;
    var lastType = null;
    var sameTypeCount = 0;

    function shownHandles() {
      var map = {};
      container.querySelectorAll('a[href]').forEach(function(a) {
        var href = a.getAttribute('href');
        if (href) map[href.replace(/\?.*$/, '')] = true;
      });
      return map;
    }

    function appendProducts(products) {
      if (!products || !products.length) return 0;
      /* Drop sold-out / zero-priced defensively */
      products = products.filter(isShowable);
      if (!products.length) return 0;
      var shown = shownHandles();
      var appended = 0;
      /* Variety pass: shuffle by type so we don't emit 5 wakeboards in a row */
      var byType = {};
      products.forEach(function(p) {
        if (!p) return;
        var cat = categorize(p) || '_other';
        (byType[cat] = byType[cat] || []).push(p);
      });
      var types = Object.keys(byType);
      if (types.length > 1) {
        var interleaved = [];
        var max = types.reduce(function(m, t) { return Math.max(m, byType[t].length); }, 0);
        for (var i = 0; i < max; i++) types.forEach(function(t) { if (byType[t][i]) interleaved.push(byType[t][i]); });
        products = interleaved;
      }
      products.forEach(function(p) {
        if (!p.handle) return;
        if (p.handle === currentHandle) return;
        var url = p.url || ('/products/' + p.handle);
        var key = url.replace(/\?.*$/, '');
        if (shown[key]) return;
        var cat = categorize(p);
        if (cat && cat === lastType) {
          sameTypeCount++;
          if (sameTypeCount >= 3) return; /* Variety gate */
        } else {
          sameTypeCount = 0;
          lastType = cat;
        }
        container.insertAdjacentHTML('beforeend', recCardHtml(p));
        shown[key] = true;
        appended++;
      });
      if (appended > 0) {
        window.dispatchEvent(new CustomEvent('sw:cards-rendered', { detail: { scope: container } }));
      }
      return appended;
    }

    function seedFromShopifyRecs() {
      if (seedDone || !productId) return Promise.resolve();
      seedDone = true;
      return fetch('/recommendations/products.json?product_id=' + productId + '&limit=12&intent=related', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data && data.products && data.products.length) appendProducts(data.products);
        })
        .catch(function() {});
    }

    function loadMore() {
      if (loading || exhausted) return;
      loading = true;
      var step = seedDone ? Promise.resolve() : seedFromShopifyRecs();
      step.then(function() {
        if (storeCache.products.length > 0) {
          var added = appendProducts(storeCache.products);
          if (added > 0) { loading = false; return; }
        }
        if (storeCache.exhaustedPage && page > storeCache.exhaustedPage) { exhausted = true; loading = false; return; }
        return fetchStorePage(page).then(function(arr) {
          page++;
          var added = appendProducts(arr);
          if (added === 0 && (storeCache.exhaustedPage || arr.length === 0)) exhausted = true;
        });
      }).then(function() { loading = false; }).catch(function() { loading = false; });
    }

    container.addEventListener('scroll', function() {
      if (container.scrollLeft + container.clientWidth > container.scrollWidth - 300) loadMore();
    }, { passive: true });

    /* DO NOT wipe Liquid-seeded fallback at init — if JS rec engine fails or finds
       nothing, the user still sees the Liquid cards. The appendProducts() dedup logic
       (shownHandles()) ensures smart picks don't duplicate Liquid seeds. */

    /* Eager initial seed */
    setTimeout(loadMore, 200);
  })();

  /* ===== Star rating render from data-stars-display ===== */
  function renderStars(el, rating) {
    var r = parseFloat(rating) || 0;
    if (r <= 0) return;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var fill;
      if (r >= i) fill = 'full';
      else if (r > i - 1) fill = 'half';
      else fill = 'empty';
      var color = (fill === 'empty') ? 'rgb(var(--color-border))' : '#F59E0B';
      var gradientId = 'sw-star-half-' + Math.random().toString(36).slice(2, 7);
      if (fill === 'half') {
        html += '<svg viewBox="0 0 24 24" aria-hidden="true">' +
          '<defs><linearGradient id="' + gradientId + '"><stop offset="50%" stop-color="#F59E0B"/><stop offset="50%" stop-color="rgb(var(--color-border))"/></linearGradient></defs>' +
          '<path fill="url(#' + gradientId + ')" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      } else {
        html += '<svg viewBox="0 0 24 24" aria-hidden="true">' +
          '<path fill="' + color + '" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      }
    }
    el.innerHTML = html;
  }
  document.querySelectorAll('[data-stars-display]').forEach(function(el) {
    renderStars(el, el.getAttribute('data-stars-display'));
  });

  /* ===== Reviews form ===== */
  (function reviews() {
    var openBtn = document.querySelector('[data-reviews-open]');
    var form = document.querySelector('[data-reviews-form]');
    var cancelBtn = document.querySelector('[data-reviews-cancel]');
    var picker = document.querySelector('[data-rating-picker]');
    var ratingInput = document.querySelector('[data-review-rating-input]');
    if (!openBtn || !form) return;

    openBtn.addEventListener('click', function() {
      form.hidden = false;
      openBtn.hidden = true;
    });
    if (cancelBtn) cancelBtn.addEventListener('click', function() {
      form.hidden = true;
      openBtn.hidden = false;
    });
    if (picker) {
      var stars = picker.querySelectorAll('[data-rating]');
      picker.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-rating]');
        if (!btn) return;
        var val = parseInt(btn.getAttribute('data-rating'), 10);
        if (!val) return;
        stars.forEach(function(s) {
          var sv = parseInt(s.getAttribute('data-rating'), 10);
          s.classList.toggle('is-active', sv <= val);
        });
        if (ratingInput) ratingInput.value = val;
      });
    }
    /* Build final contact[body] with rating prefix on submit */
    form.addEventListener('submit', function(e) {
      var bodyField = form.querySelector('textarea[name="contact[body]"]');
      var rating = ratingInput ? parseInt(ratingInput.value, 10) : 0;
      if (!rating) {
        e.preventDefault();
        alert('Please select a star rating.');
        return;
      }
      if (bodyField && bodyField.value.indexOf('Rating:') !== 0) {
        bodyField.value = 'Rating: ' + rating + '/5\n\n' + bodyField.value;
      }
    });
  })();

  /* ===== Jump-to-reviews from star rating click ===== */
  document.querySelectorAll('[data-rating-jump]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      var reviewsBtn = document.querySelector('.product-tabs__tab[data-tab="reviews"]');
      if (reviewsBtn) reviewsBtn.click();
      var anchor = document.getElementById('product-tabs-anchor');
      if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();

/* === Sticky mobile Add to Cart bar === */
(function() {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;
  var mainAtc = document.querySelector('.product-form__atc');
  var btn = bar.querySelector('[data-sticky-atc-btn]');
  if (!mainAtc || !btn) return;

  document.body.classList.add('has-sticky-atc');

  function update() {
    if (window.innerWidth >= 768) return bar.classList.remove('is-visible');
    var rect = mainAtc.getBoundingClientRect();
    var offScreen = rect.bottom < 0 || rect.top > window.innerHeight;
    bar.classList.toggle('is-visible', offScreen);
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);

  btn.addEventListener('click', function() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }
  });
})();

/* === Product Page Tabs — accordion behavior
   Click inactive tab: open that tab (close others).
   Click currently-active tab: close it (no tab selected — all panels hidden).
   On page load: close all tabs by default so users CHOOSE what to read. */
(function() {
  var tabs = document.querySelector('[data-product-tabs]');
  if (!tabs) return;
  var tabBtns = tabs.querySelectorAll('.product-tabs__tab');
  var panels = tabs.querySelectorAll('.product-tabs__panel');

  function closeAll() {
    tabBtns.forEach(function(b) {
      b.classList.remove('active');
      b.setAttribute('aria-selected', 'false');
    });
    panels.forEach(function(p) {
      p.hidden = true;
      p.classList.remove('active');
    });
  }

  function openTab(id) {
    tabBtns.forEach(function(b) {
      var on = b.getAttribute('data-tab') === id;
      b.classList.toggle('active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function(p) {
      var show = p.getAttribute('data-panel') === id;
      p.hidden = !show;
      p.classList.toggle('active', show);
    });
  }

  /* All tabs start collapsed — founder override: buyers decide what to read. */
  closeAll();

  tabBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id = btn.getAttribute('data-tab');
      if (btn.classList.contains('active')) {
        /* Click active tab → close it */
        closeAll();
      } else {
        openTab(id);
      }
    });
  });
})();

/* === Price Alert Toggle === */
(function() {
  var openBtn = document.querySelector('[data-price-alert-open]');
  var panel = document.querySelector('[data-price-alert]');
  if (!openBtn || !panel) return;
  openBtn.addEventListener('click', function() {
    panel.hidden = !panel.hidden;
    if (!panel.hidden) {
      var email = panel.querySelector('input[type="email"]');
      if (email) email.focus();
    }
  });
})();

/* === Collection Infinite Scroll (self-healing across AJAX collection switches) === */
(function() {
  var root = document.querySelector('[data-infinite-collection]');
  if (!root) return;

  function getState() {
    var sentinel = root.querySelector('.coll-infinite-sentinel');
    var grid = root.querySelector('.coll-product-grid');
    return { sentinel: sentinel, grid: grid };
  }

  var loading = false;
  var exhausted = false;
  var io = null;
  var observedSentinel = null;

  function attachObserver() {
    var sentinel = root.querySelector('.coll-infinite-sentinel');
    if (!sentinel || sentinel === observedSentinel) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) { if (entry.isIntersecting) loadMore(); });
    }, { rootMargin: '2400px 0px' });
    io.observe(sentinel);
    observedSentinel = sentinel;
    /* Reset exhausted when a new sentinel appears (AJAX switched collection) */
    exhausted = false;
    /* Eagerly prefetch next page immediately so content appears before user reaches it */
    setTimeout(loadMore, 120);
  }

  /* Re-attach when content changes (AJAX collection switch replaces innerHTML) */
  var mo = new MutationObserver(function() {
    exhausted = false;
    attachObserver();
  });
  mo.observe(root, { childList: true, subtree: true });

  function loadMore() {
    if (loading || exhausted) return;
    var state = getState();
    if (!state.sentinel || !state.grid) { exhausted = true; return; }
    var nextUrl = state.sentinel.getAttribute('data-next-url');
    if (!nextUrl) { exhausted = true; return; }
    loading = true;
    state.sentinel.classList.add('is-loading');

    fetch(nextUrl, { headers: { 'Accept': 'text/html' } })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.coll-product-grid');
        var newSentinel = doc.querySelector('.coll-infinite-sentinel');
        var newEndMarker = doc.querySelector('[data-end-marker]');

        if (newGrid) {
          /* Append new product cards into the existing grid */
          var cards = newGrid.children;
          var frag = document.createDocumentFragment();
          while (cards.length) frag.appendChild(cards[0]);
          state.grid.appendChild(frag);
        }

        /* Replace the sentinel or show end-of-list marker */
        if (newSentinel) {
          state.sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
          state.sentinel.classList.remove('is-loading');
        } else if (newEndMarker) {
          state.sentinel.replaceWith(newEndMarker.cloneNode(true));
          exhausted = true;
        } else {
          state.sentinel.remove();
          exhausted = true;
        }
      })
      .catch(function() {
        var s = getState().sentinel;
        if (s) s.classList.remove('is-loading');
      })
      .then(function() { loading = false; });
  }

  /* Initial attach + scroll fallback for no-IntersectionObserver browsers */
  if (window.IntersectionObserver) {
    attachObserver();
  } else {
    window.addEventListener('scroll', throttledCheck, { passive: true });
  }

  var scrollTick = null;
  function throttledCheck() {
    if (scrollTick) return;
    scrollTick = requestAnimationFrame(function() {
      scrollTick = null;
      var s = root.querySelector('.coll-infinite-sentinel');
      if (!s) return;
      var rect = s.getBoundingClientRect();
      if (rect.top < window.innerHeight + 800) loadMore();
    });
  }
})();

/* === Cart page: auto-submit on quantity change + smart recommendations ===
   - Any +/- button or direct input change in /cart triggers form submit → cart refreshes
   - Reads [#cart-items-json] for items-in-cart, derives complementary categories,
     fetches /products.json and renders up to 6 cross-sell cards in the sidebar. */
(function() {
  var cartForm = document.getElementById('main-cart-form');
  if (!cartForm) return;

  /* Auto-submit on quantity change (debounced) */
  var submitTimer = null;
  function scheduleSubmit() {
    if (submitTimer) clearTimeout(submitTimer);
    submitTimer = setTimeout(function() { cartForm.submit(); }, 650);
  }
  cartForm.addEventListener('click', function(e) {
    if (e.target.closest('[data-qty-minus], [data-qty-plus]')) scheduleSubmit();
  });
  cartForm.addEventListener('change', function(e) {
    if (e.target.matches && e.target.matches('[data-cart-qty]')) scheduleSubmit();
  });

  /* --- Recommendations ---
     Runs on the cart page only. Uses the same categorize() + CROSS_SELL + isShowable
     from the rec engine IIFE above (functions are exposed via their closure
     when the rec engine script runs; however from a different IIFE we can't access
     them directly. So instead we fetch /products.json here too and re-implement
     the minimal category logic. Lightweight duplication < cross-IIFE coupling.) */
  var recsPanel = document.querySelector('[data-cart-recs]');
  var recsTrack = document.querySelector('[data-cart-recs-track]');
  var itemsEl = document.getElementById('cart-items-json');
  if (!recsPanel || !recsTrack || !itemsEl) return;

  var cartItems;
  try { cartItems = JSON.parse(itemsEl.textContent || '[]'); }
  catch (e) { return; }
  if (!cartItems.length) return;

  function norm(s) { return (s || '').toString().toLowerCase(); }
  function categorize(p) {
    if (!p) return null;
    var v = norm(p.vendor).replace(/^\d{4}\s*/, '');
    var t = norm(p.product_type || p.type).replace(/^\d{4}\s*/, '');
    var sport =
      /bataleon|rome/.test(v) ? 'snow' :
      /hyperlite/.test(v)     ? 'wake' :
      /ho\s*sports/.test(v)   ? 'ski'  : '';
    if (!sport) {
      if (/snow/.test(t)) sport = 'snow';
      else if (/wake|foil|tube|surf/.test(t)) sport = 'wake';
      else if (/\bski\b/.test(t)) sport = 'ski';
    }
    if (sport === 'wake') {
      if (/bag/.test(t)) return 'wake_bag';
      if (/rope/.test(t)) return 'wake_rope';
      if (/vest|pfd|jacket|comp/.test(t)) return 'wake_vest';
      if (/accessor/.test(t)) return 'wake_accessory';
      if (/binding/.test(t)) return 'wake_binding';
      if (/knee/.test(t)) return 'kneeboard';
      if (/surf/.test(t)) return 'wake_surf';
      if (/tube/.test(t)) return 'wake_tube';
      if (/foil/.test(t)) return 'wake_foil';
      if (/apparel|boardshort|rash/.test(t)) return 'wake_apparel';
      if (/wake|board|boat|cable/.test(t)) return 'wake_board';
      return 'wake_other';
    }
    if (sport === 'ski') {
      if (/bag/.test(t)) return 'ski_bag';
      if (/rope/.test(t)) return 'ski_rope';
      if (/vest|pfd|jacket/.test(t)) return 'wake_vest';
      if (/glove|wetsuit|westuit/.test(t)) return 'ski_glove';
      if (/boot|binding/.test(t)) return 'ski_boot';
      if (/accessor/.test(t)) return 'ski_accessory';
      if (/apparel/.test(t)) return 'ski_apparel';
      if (/ski/.test(t)) return 'waterski';
      return 'ski_other';
    }
    if (sport === 'snow') {
      if (/bag/.test(t)) return 'snow_bag';
      if (/boot/.test(t)) return 'snow_boot';
      if (/binding/.test(t)) return 'snow_binding';
      if (/accessor/.test(t)) return 'snow_accessory';
      if (/apparel/.test(t)) return 'snow_apparel';
      return 'snowboard';
    }
    return null;
  }
  var CROSS = {
    wake_board: ['wake_binding','wake_vest','wake_rope','wake_bag','wake_apparel','helmet','kneeboard','wake_accessory'],
    wake_binding: ['wake_board','wake_vest','wake_bag','wake_rope','wake_apparel'],
    wake_surf: ['wake_vest','wake_rope','wake_bag','wake_accessory'],
    wake_vest: ['wake_board','wake_surf','waterski','wake_rope'],
    wake_tube: ['wake_rope','wake_vest','wake_accessory'],
    wake_foil: ['wake_vest','wake_rope','wake_bag'],
    wake_rope: ['wake_board','wake_binding','wake_vest'],
    wake_bag: ['wake_board','wake_binding','wake_vest'],
    wake_accessory: ['wake_board','wake_binding','wake_vest','wake_bag'],
    wake_apparel: ['wake_board','wake_binding','wake_vest'],
    kneeboard: ['wake_vest','wake_rope','wake_accessory'],
    waterski: ['ski_boot','wake_vest','ski_rope','ski_glove','ski_bag'],
    ski_boot: ['waterski','wake_vest','ski_rope','ski_glove'],
    ski_rope: ['waterski','ski_boot','wake_vest'],
    ski_glove: ['waterski','ski_boot'],
    ski_bag: ['waterski','ski_boot'],
    ski_accessory: ['waterski','ski_boot','ski_rope'],
    ski_apparel: ['waterski','ski_boot'],
    snowboard: ['snow_binding','snow_boot','snow_bag','snow_apparel'],
    snow_binding: ['snowboard','snow_boot','snow_bag'],
    snow_boot: ['snowboard','snow_binding','snow_bag'],
    snow_bag: ['snowboard','snow_binding'],
    snow_accessory: ['snowboard','snow_binding'],
    snow_apparel: ['snowboard']
  };
  function isShowable(p) {
    if (!p) return false;
    if (p.variants && p.variants.length) {
      return p.variants.some(function(v) {
        if (v.available === false) return false;
        var price = parseFloat(v.price);
        return isFinite(price) && price > 0;
      });
    }
    return false;
  }
  function priceOf(p) {
    if (p.variants && p.variants.length) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (v && v.available !== false && v.price) return parseFloat(v.price);
      }
    }
    return 0;
  }
  function imgOf(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img === 'object') img = img.src;
    if (img && img.indexOf('http') === 0 && img.indexOf('width=') === -1) {
      img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=280';
    }
    return img;
  }
  function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  /* 1. Compute wanted categories from items in cart */
  var wanted = {};
  var cartHandles = {};
  cartItems.forEach(function(ci) {
    cartHandles[ci.handle] = true;
    var cat = categorize(ci);
    if (!cat) return;
    (CROSS[cat] || []).forEach(function(w) { wanted[w] = true; });
  });
  if (!Object.keys(wanted).length) return;

  /* 2. Fetch store catalog pages, render up to 6 matching picks */
  var allFetched = [];
  function fetchPage(page) {
    return fetch('/products.json?limit=50&page=' + page, { headers: {'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(data){
        return (data && data.products) || [];
      })
      .catch(function(){ return []; });
  }

  fetchPage(1).then(function(a){ return fetchPage(2).then(function(b){ return a.concat(b); }); })
    .then(function(products) {
      var picks = [];
      var catCount = {};
      products.forEach(function(p) {
        if (picks.length >= 6) return;
        if (!p.handle || cartHandles[p.handle]) return;
        if (!isShowable(p)) return;
        var cat = categorize(p);
        if (!cat || !wanted[cat]) return;
        catCount[cat] = (catCount[cat] || 0) + 1;
        if (catCount[cat] > 2) return; /* variety: max 2 per category */
        picks.push(p);
      });
      if (picks.length === 0) return;

      recsTrack.innerHTML = picks.map(function(p) {
        var variantId = p.variants && p.variants[0] && p.variants[0].id;
        var price = priceOf(p);
        var priceStr = price.toFixed(2) + ' AED';
        var img = imgOf(p);
        var imgHtml = img ? '<img src="' + escHtml(img) + '" alt="' + escHtml(p.title) + '" loading="lazy">' : '';
        return '<a href="/products/' + escHtml(p.handle) + '" class="cart-rec-card">'
          + '<div class="cart-rec-card__img">' + imgHtml
          + (variantId ? '<form action="/cart/add" method="post" style="position:absolute;inset:0;pointer-events:none"><input type="hidden" name="id" value="' + variantId + '"><button type="submit" class="cart-rec-card__add" aria-label="Add to cart" style="pointer-events:auto"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button></form>' : '')
          + '</div>'
          + '<p class="cart-rec-card__vendor">' + escHtml(p.vendor || '') + '</p>'
          + '<p class="cart-rec-card__title">' + escHtml(p.title || '') + '</p>'
          + '<p class="cart-rec-card__price">' + escHtml(priceStr) + '</p>'
          + '</a>';
      }).join('');
      recsPanel.hidden = false;
    });
})();



  /* v8 — Country switcher (KW/SA/AE) toggle */
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-country-switcher-toggle]');
    if (toggle) {
      e.preventDefault();
      var switcher = toggle.closest('[data-country-switcher]');
      var panel = switcher.querySelector('[data-country-switcher-panel]');
      var isOpen = !panel.hidden;
      /* close any other open switcher panels */
      document.querySelectorAll('[data-country-switcher-panel]').forEach(function(p) {
        if (p !== panel) {
          p.hidden = true;
          var t = p.parentElement.querySelector('[data-country-switcher-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      panel.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
      return;
    }
    if (!e.target.closest('[data-country-switcher-panel]')) {
      document.querySelectorAll('[data-country-switcher-panel]').forEach(function(p) { p.hidden = true; });
      document.querySelectorAll('[data-country-switcher-toggle]').forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-country-switcher-panel]').forEach(function(p) { p.hidden = true; });
      document.querySelectorAll('[data-country-switcher-toggle]').forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
    }
  });


  /* v12 — iOS touchstart fallback for close-on-outside (Mobile Safari sometimes doesn't
     fire delegated `click` events on non-interactive targets). */
  document.addEventListener('touchstart', function(e) {
    if (e.target.closest('[data-country-switcher]')) return;  /* let click handle the toggle */
    var anyOpen = document.querySelector('[data-country-switcher-panel]:not([hidden])');
    if (!anyOpen) return;
    document.querySelectorAll('[data-country-switcher-panel]').forEach(function(p) { p.hidden = true; });
    document.querySelectorAll('[data-country-switcher-toggle]').forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
  }, { passive: true });
